import Vue from 'vue'
import _sortBy from 'lodash/sortBy'

export default {
    namespaced: true,

    state: {
        products: [],
        configurations: [],
        selection: {
            initialKey: null,
            initialMap: null,
            currentKey: null,
            currentMap: null,
        },
        currentConfig: {}
    },

    getters: {
        formIsValid(state, getters) {
            return getters.productsAreSelected && getters.productConfigsAreValid
        },

        serializeProducts(state) {
            let res = {}
            Object.entries(state.currentConfig).map(pair => {
                res[pair[0].toLowerCase()] = Object.values(pair[1].slots).filter(s => s.rate !== null)
            })
            return res
        },

        productsAreSelected(state) {
            return Object.values(state.currentConfig).reduce((accum, p) => accum + p.visible, 0) > 0
        },

        productConfigsAreValid(state) {
            return Object.values(state.currentConfig).reduce((valid, product) => {
                return valid && Object.values(product.slots).reduce((valid, slot) => {
                    if(!slot.rate) return valid // if no rate, then we consider is valid
                    return valid && (slot.config?.valid ?? false) // otherwise we check config validation
                }, valid)
            }, true)
        },

        getPrice(state) {
            if(!state.selection.currentKey) return null
            return state.configurations.find(c => c.key === state.selection.currentKey).price ?? null
        },

        getFormattedPrice: (state, getters) => {
            if(isNaN(getters.getPrice)) return null
            return (getters.getPrice / 100).toFixed(2).toString().replace('.',',')
        },

        getDefaultProductTypeRate: state => productType => {
            let product = state.products.find(product => product.reference === productType)

            // find rate flagged as default choice
            let defaultRate = product.rates.find(product => product.default === true)
            if(defaultRate) return defaultRate

            // otherwise return first rate in sorted list
            return _sortBy(product.rates, 'index')[0] ?? null;
        },

        getConfigurationsDiff: (state, getters) => (slotKey, rateId) => {
            let altKey = fromMapToKey(Object.assign({}, state.selection.currentMap, {[slotKey]: rateId }));
            let altPrice = state.configurations.find(c => c.key === altKey).price ?? getters.getPrice
            return altPrice - getters.getPrice
        },
    },

    mutations: {

        setProducts(state, products) {
            state.products = products
        },

        setConfigurations(state, configurations) {
            state.configurations = configurations
        },

        setInitialSelection(state, selection) {
            state.selection.initialKey = selection
            state.selection.initialMap = fromKeyToMap(selection)
            state.selection.initialPrice = state.configurations.find(c => c.key === selection).price ?? null
            state.selection.currentKey = selection
            state.selection.currentMap = fromKeyToMap(selection)
        },

        // --------------------------------------------------
        // --------------------------------------------------

        initProductSlots(state) {
            state.products.forEach(product => {
                Vue.set(state.currentConfig, product.reference, buildSlotData(product))
            })
        },

        applyInitialSlotRates(state) {
            // for CELL, FIX, NET, TV
            for(const productType in state.currentConfig){
                if(! state.currentConfig.hasOwnProperty(productType)) continue
                const product = state.currentConfig[productType]
                let slotsVisible = 0
                // FOR CELL1, CELL2, CELL3, etc...
                for(const slotKey in product.slots){
                    if(! product.slots.hasOwnProperty(slotKey) ) continue

                    if(state.selection.initialMap[slotKey] !== 0) {
                        // product.slots[slotKey].rate = state.selection.initialMap[slotKey]
                        let rateId = state.selection.initialMap[slotKey]
                        product.slots[slotKey].rate = getProductTypeRateById(state, productType, rateId)
                        slotsVisible++
                    }
                }
                product.visible = slotsVisible
            }

        },

        updateProductSlotRate(state, { productType, slotKey, rate }) {
            if(!state.currentConfig[productType]) return
            if(!state.currentConfig[productType].slots[slotKey]) return
            state.currentConfig[productType].slots[slotKey].rate = rate

            if(!state.selection.currentMap.hasOwnProperty(slotKey)) return
            state.selection.currentMap[slotKey] = rate?.id ?? 0
            state.selection.currentKey = fromMapToKey(state.selection.currentMap)
        },

        updateProductSlotConfiguration(state, { productType, slotKey, config }) {
            state.currentConfig[productType].slots[slotKey].config = config
        },

        updateProductSlotsVisible(state, { productType, slotsVisible }) {
            state.currentConfig[productType].visible = slotsVisible
        },

    }
}

function getProductTypeRateById(state, type, id) {
    return getRatesByProductType(state, type)?.find(rate => rate.id === id)
}

function getRatesByProductType(state, type) {
    return state.products.find(product => product.reference === type)?.rates
}

function buildSlotData(product) {
    let data = {
        visible: 0,
        slots: {}
    }

    for(let i = 0; i < product.slots_max; i++){
        let slotKey = product.reference.concat(i+1)
        data.slots[slotKey] = {
            rate: null,
            config: null
        }
    }

    return data
}

function fromKeyToMap(key) {
    // CELL1:0.CELL2:0.CELL3:0.NET1:0.FIX1:0.TV1:0
    let map = {}

    key.split('.').map(slot => slot.split(':')).map(s => {
        map[s[0]] = parseInt(s[1])
    })

    return map
}

function fromMapToKey(map) {
    // { CELL1: 0, CELL2: 0, CELL3: 0, FIX1: 0, NET1: 0, TV1: 0 }
    let key = []

    for (const slot in map) {
        if (!map.hasOwnProperty(slot)) continue
        key.push(slot + ':' + map[slot])
    }
    return key.join('.')
}
